import { FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';
import { pxToRem } from 'Styles/utils/utils';

export const Box = styled(FlexContainer)`
  background-color: ${({ theme: { colors } }) => colors.white};
  border-radius: ${({ theme: { reference } }) => reference.dimension_08};
  width: 100%;
  margin: 0 auto;
  max-width: ${pxToRem(450)};
  box-shadow: ${({ theme: { boxShadows } }) =>
    `${boxShadows.fds_elevation_500.x} ${boxShadows.fds_elevation_500.y} 4px ${boxShadows.fds_elevation_500.spread} ${boxShadows.fds_elevation_500.color}`};
`;

export const ButtonsContainer = styled(FlexContainer)`
  max-width: 300px;
`;

export const MandatoryInfo = styled(FlexContainer)`
  background: ${({ theme: { colors } }) => colors.danger_200};
  padding: ${({ theme: { spacing } }) => spacing.spacing_16}
    ${({ theme: { spacing } }) => spacing.spacing_24};
  border-bottom-left-radius: ${({ theme: { reference } }) => reference.dimension_08};
  border-bottom-right-radius: ${({ theme: { reference } }) => reference.dimension_08};
`;

export const BoxContent = styled(FlexContainer)`
  width: 100%;
  padding: ${({ theme: { spacing } }) => spacing.spacing_16};
`;
